import config from 'config';
import _last from 'lodash/last';

import { Status, States } from '@sift/resift/models/Status';

// ------------------------------------
// Constants
// ------------------------------------
export const AUTHENTICATION_PERSON_FETCH = 'AUTHENTICATION_PERSON_FETCH';
export const AUTHENTICATION_PERSON_FETCH_SUCCESS = 'AUTHENTICATION_PERSON_FETCH_SUCCESS';
export const AUTHENTICATION_PERSON_FETCH_ERROR = 'AUTHENTICATION_PERSON_FETCH_ERROR';

// ------------------------------------
// Actions
// ------------------------------------
export function fetchAuthenticatedPerson() {
  return {
    type: AUTHENTICATION_PERSON_FETCH,
    payload: {},
  };
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [AUTHENTICATION_PERSON_FETCH]: (state, action) => {
    return {
      ...state,
      status: new Status(States.LOADING),
    };
  },
  [AUTHENTICATION_PERSON_FETCH_SUCCESS]: (state, action) => {
    const person = action.payload.data;

    return {
      ...state,
      person,
      status: new Status(States.NORMAL),
    };
  },
  [AUTHENTICATION_PERSON_FETCH_ERROR]: (state, action) => {
    return {
      ...state,
      status: new Status(States.ERROR),
    };
  },
};

// ------------------------------------
// Reducer
// ------------------------------------
export const initialState = {
  api: {
    path: config.API_ENV,
    token: getAuthToken(),
    login: config.LOGIN,
  },
  person: {},
  status: new Status(States.LOADING),
};

function getAuthToken() {
  let subdomain = window.location.hostname.split('.')[0];

  let regexpString = `( |^)auth_token_${subdomain}=([^ ;]+)`;
  let subdomainTokenMatch = document.cookie.match(regexpString);

  if (subdomainTokenMatch) {
    return _last(subdomainTokenMatch);
  }

  let legacyTokenMatch = document.cookie.match(/( |^)auth_token=([^ ;]+)/);

  return legacyTokenMatch ? _last(legacyTokenMatch) : '';
}

export default function authenticationReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
